'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';

import type { SiteSearchListContextType } from '@/analytics/events';
import { topicPath } from '@/helpers/linkHelpers';
import ClockCounterClockwise from '@/icons/react/ClockCounterClockwise';
import { useSiteSearch } from '@/providers';

interface SiteSearchTopicLinkProps {
  id?: string;
  slug: string;
  label: ReactNode;
  name: string;
  index?: number;
  listContext: SiteSearchListContextType;
  updateRecent?: boolean;
  linkURL?: string;
}

const resultLinkClasses =
  'py-1 flex gap-2 items-center hover:bg-gray-200 dark:hover:bg-gray-700';

export function SiteSearchTopicLink({
  id,
  slug,
  label,
  name,
  index,
  listContext,
  updateRecent = true,
  linkURL,
}: SiteSearchTopicLinkProps) {
  const { handleTopicSelection, activeIndex } = useSiteSearch();
  const showRecentIcon = listContext === 'recently-viewed';
  const href = linkURL || topicPath(slug);

  return (
    <Link
      key={id}
      id={id}
      className={resultLinkClasses}
      aria-selected={activeIndex === index}
      href={href}
      onClick={() =>
        handleTopicSelection({
          name: name,
          slug: slug,
          updateRecent: updateRecent,
          listContext: listContext,
          listIndex: index,
        })
      }
    >
      {showRecentIcon && <ClockCounterClockwise />}
      {label}
    </Link>
  );
}
